import type { UseCase } from '@contexts/shared/application';
import { booleanValueObject, uuidValueObject } from '@contexts/shared/domain';
import type { UpdateApiKeyAccessInput, User, UserRepository } from '@contexts/users/domain';

export type UpdateApiKeyAccessUseCase = UseCase<UpdateApiKeyAccessInput, User>;

export function updateApiKeyAccessBuilder(
	userRepository: UserRepository
): UpdateApiKeyAccessUseCase {
	return async function updateApiKeyAccess(input: UpdateApiKeyAccessInput): Promise<User> {
		const id = uuidValueObject().validate('id', input.id);
		const hasApiKey = booleanValueObject().validate('hasApiKey', input.hasApiKey);

		return userRepository.updateApiKeyAccess({ id, hasApiKey });
	};
}
